<template>
  <div class="news">
    <div class="top-nav">
      <nav-bar @moveTo="moveTo" @getNewsList="getNewsList"></nav-bar>
    </div>
    <TopImg></TopImg>
    <div class="news-con">
      <div id="J_zwBbb" class="zw" :class="{ active: curTab === 0 }"></div>
      <ul id="J_newsTabBbb" class="news_tab">
        <li
          v-for="(item, index) in tabsList"
          :key="index"
          class="news_tab_item"
          :class="{ active: curTab === index }"
          @click="changeTab(index)"
        >
          <span> {{ item.catname }}</span>
        </li>
      </ul>
      <div class="news-content">
        <ul v-if="isLoaded && newsList.length > 0" class="news_list">
          <li
            v-for="(item, index) in newsList"
            :key="index"
            class="news_list_item"
            @click="jumpDetail(item)"
          >
            <div class="news-item">
              <div class="newsImg">
                <img v-if="item.thumb" :src="item.thumb" />
              </div>
              <a target="_blank">
                <p class="news_title">
                  <span class="news_title_tag">[{{ getType }}]</span>
                  <span class="tit">{{ item.title }}</span>
                </p>
                <p class="news_des" v-html="item.description"></p>
              </a>
              <span class="news_time">
                <span class="line"></span>
                <span class="month">{{ item.day }}</span>
                <span class="day">{{ item.month }}</span>
                <span class="txt">日</span>
              </span>
            </div>
          </li>
        </ul>
        <ul v-if="isLoaded && newsList.length <= 0" class="news_list">
          <li class="no-data">敬请期待</li>
        </ul>
      </div>
      <div class="more_btn" @click="getNewsList"><span>加载更多</span></div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import TopImg from "./components/TopImg";
import NavBar from "./components/Nav";
import Footer from "./components/Footer";
import Common from "./components/Common";
import debounce from "lodash.debounce";
import tool from '@/libs/utils.js'

export default {
  name: "News",
  components: {
    TopImg,
    NavBar,
    Footer
  },
  mixins: [Common],
  data() {
    return {
      newsList: [],
      page: 1,
      isLastPage: false,
      isLoaded: false,
      totalNewsNum: 0
    };
  },
  computed: {
    ...mapState(["curTab", "tabsList"]),
    getType() {
      if(this.tabsList.length <= 0) return;
      return this.tabsList[this.curTab].catname;
    }
  },
  created(){
    if(tool.checkOperaSys() !== 'pc'){
      let params = tool.getUrlParam(), jump_url = `${process.env.VUE_APP_M_URL}news`;
      const urlParams = tool.combinationUrlParam(params);
      if(urlParams){
        jump_url += `?${urlParams}`
      }
      window.location.href = jump_url
    }
  },
  mounted() {
    this.getNewsList();
    this.getWinW();
    window.addEventListener("resize",  debounce(
      this.getWinW, 
      300,
      ),{
      'leading': true,
      'trailing': false
    });
  },
  methods: {
    ...mapActions(["changeCurTab"]),
    getWinW() {
      const winW = document.body.clientWidth;
      const conW = document.getElementById("J_newsTabBbb").clientWidth;
      document.getElementById("J_zwBbb").style.width =
        (winW - conW) / 1.8 + "px";
    },
    changeTab(ind) {
      this.isLoaded = false;
      this.page = 1;
      this.newsList = [];
      this.isLastPage = false;
      this.changeCurTab(ind);
      this.getNewsList(this.tabsList[ind].catid);
    },
    getDate(unixTime) {
      const time = new Date(unixTime);
      const month =
        time.getMonth() + 1 < 10
          ? "0" + (time.getMonth() + 1)
          : time.getMonth() + 1;
      const day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
      return {
        month,
        day
      };
    },
    showTips(){
      this.$toast({
        message: "已经是最后一页",
        duration: 1000
      });
    },
    async getNewsList() {
      if (this.isLastPage) {
        this.showTips();
        return;
      }
      this.$toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true
      });
      try {
        let params = {
          df: "catid,title,description,inputtime,thumb",
          s: 6,
          sort: 'data.inputtime',
          page: this.page
        }
        if(this.curTab) {
          params['filter:catid'] = this.tabsList[this.curTab].catid
        }
        const {
          data: { items, pagination: { total } }
        } = await this.$api.getKMSConfig("article", params);
        this.$toast.clear();
        this.isLoaded = true;
        const len = this.newsList.length;
        if (len >= total && this.page !== 1) {
          this.isLastPage = true;
          this.showTips();
          return;
        }
         for (let i = 0, itemLen = items.length; i < itemLen; i++) {
          const item = items[i];
          const date = item.inputtime ? item.inputtime : item.created;
          Object.assign(item, this.getDate(date));
        }
        this.newsList = this.newsList.concat(items);
        this.page++;
      } catch (error) {
        this.$toast(error?.desc || "Error");
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "./assets/css/mixin.less";
.age16,
.pin-btns {
  display: none;
}
.news {
  .top-nav {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }
  .news-con {
    position: relative;
    .mixin_com(min-height, 1300);
    .mixin_com(padding-bottom, 60);

    background:
      #2d3651 url("~@/assets/images/news/bg.png") no-repeat center top /
      100%;
  }
  .zw {
    position: absolute;
    top: 0;
    left: 0;
    .mixin_com(width, 280);
    .mixin_com(height, 54);

    background-color: rgba(128, 139, 168, 0.7);
    &.active {
      .mixin_com(height, 64);
      .mixin_com(margin-top, -10);
      .mixin_com(font-size, 36);
      .mixin_com(line-height, 64);

      color: #e5f4ff;
      background-color: #262f4c;
    }
  }
  .news_tab {
    position: absolute;
    top: 0;
    left: 50%;
    display: flex;
    .mixin_com(width, 1200);
    .mixin_com(height, 54);
    .mixin_com(margin-left, -600);
    .mixin_com(font-size, 30);
    .mixin_com(line-height, 54);

    color: #fff;
    .news_tab_item {
      float: left;
      .mixin_com(width, 232);

      height: 100%;
      .mixin_com(margin-left, 10);

      cursor: pointer;
      background-color: #6c7e9d;
      &:nth-child(5) {
        margin-right: 0;
      }
      span {
        display: block;
        width: 100%;
        height: 100%;
        text-align: center;
      }
      &.active {
        .mixin_com(height, 64);
        .mixin_com(margin-top, -10);
        .mixin_com(font-size, 36);
        .mixin_com(line-height, 64);

        color: #e5f4ff;
        background-color: #262f4c;
      }
    }
  }
  .news-content {
    .mixin_com(width, 1200);
    .mixin_com(min-height, 1128);
    .mixin_com(padding-top, 54);

    margin: 0 auto;
  }
  .news_list {
    position: relative;
    width: 100%;
    .mixin_com(font-size, 18);
  }
  .news-item {
    position: relative;
    box-sizing: border-box;
    display: flex;
    width: 100%;
    .mixin_com(height, 160);
    .mixin_com(padding, 10);
    .mixin_com(margin-bottom, 28);

    cursor: pointer;
    background:
      url("~@/assets/images/news/con_bg.jpg") no-repeat left top /
      cover;
    a {
      .mixin_com(width, 700);
      .mixin_com(margin-top, 20);
      .mixin_com(margin-left, 20);

      color: #7e7e7e;
    }
    .newsImg {
      display: flex;
      align-items: center;
      justify-content: center;
      .mixin_com(width, 228);
      .mixin_com(height, 140);

      overflow: hidden;
      background-color: #ececec;
      img {
        width: 100%;
      }
    }
    .news_title {
      .mixin_com(font-size, 24);

      color: #0a2a4a;
      span {
        display: inline-block;
        .mixin_com(height, 40);
        .mixin_com(line-height, 40);
      }
      .tit {
        .mixin_com(width, 615);
        .mixin_com(margin-left, 15);

        overflow: hidden;
        .mixin_com(line-height, 42);

        text-overflow: ellipsis;
        word-break: keep-all;
        word-wrap: normal;
        white-space: nowrap;
        vertical-align: bottom;
      }
      &::after {
        display: block;
        .mixin_com(width, 698);
        .mixin_com(height, 2);
        .mixin_com(margin-top, 12);
        .mixin_com(margin-bottom, 15);

        content: "";
        background-color: rgba(180, 180, 180, 0.2);
      }
    }
    .news_des {
      .mixin_com(width, 698);
      .mixin_com(height, 50);

      overflow: hidden;
      .mixin_com(line-height, 25);
    }
    .news_title_tag {
      font-weight: bold;
      color: #6683a6;
    }
    .news_time {
      position: absolute;
      .mixin_com(right, 58);
      .mixin_com(bottom, 28);
      .mixin_com(width, 152);
      .mixin_com(height, 120);

      font-family: FZFW-ZhuZiAOldMin-B--GB1-0;
      .mixin_com(font-size, 75);
      .mixin_com(line-height, 75);

      color: #6683a6;
    }
    .line {
      position: absolute;
      .mixin_com(bottom, 50);
      .mixin_com(left, 28);
      .mixin_com(width, 165);
      .mixin_com(height, 1);

      background: #234a78;
      .transform(rotate(-45deg));
    }
    .month {
      position: absolute;
      .mixin_com(right, -32);
      .mixin_com(bottom, -22);

      font-style: italic;
    }
    .day {
      position: absolute;
      top: 0;
      left: 0;
      font-style: italic;
    }
    .txt {
      position: absolute;
      .mixin_com(top, -18);
      .mixin_com(right, 8);
      .mixin_com(font-size, 40);

      font-style: italic;
    }
  }
  .no-data {
    .mixin_com(padding-top, 100);
    .mixin_com(font-size, 20);

    color: #fff;
    text-align: center;
  }
  .more_btn {
    .mixin_com(width, 452);
    .mixin_com(height, 56);

    margin: 0 auto;
    overflow: hidden;
    cursor: pointer;
    background-color: #193c60;
    span {
      display: block;
      .mixin_com(width, 440);
      .mixin_com(height, 46);

      margin: 0 auto;
      .mixin_com(margin-top, 5);
      .mixin_com(font-size, 26);
      .mixin_com(line-height, 46);

      color: #fff;
      text-align: center;
      border: solid 1px #698097;
    }
  }
}
</style>
<style>
.van-toast--unclickable {
  overflow: auto !important;
}
</style>
